<sgt-multi-select
  [options]="options"
  [settings]="settings"
  [(ngModel)]="idsSemanas"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()">
</sgt-multi-select>
